// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify, type ThemeDefinition } from "vuetify";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import { useI18n } from "vue-i18n";
import { i18n } from "@/i18n";

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: "#ffffff",
    surface: "#ffffff",
    primary: "#8ABCE4",
    secondary: "#5c7c94",
    error: "#e57373",
    info: "#8ABCE4",
    success: "#8ABCE4",
    warning: "#ffb74d",
    "grey-darken-1": "#78909c",
    "grey-darken-2": "#546e7a",
    "grey-darken-3": "#37474f"
  }
};

export default createVuetify({
  locale: {
    adapter: createVueI18nAdapter({ i18n: i18n as any, useI18n })
  },
  theme: {
    defaultTheme: "lightTheme",
    themes: {
      lightTheme
    }
  }
});
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
